import { Check } from "lucide-react";

const STEPS = [
  { id: "select", label: "Upload file", icon: "↑" },
  { id: "map", label: "Map columns", icon: "⇄" },
  { id: "preview", label: "Preview", icon: "◎" },
  { id: "requirements", label: "Requirements", icon: "✎" },
  { id: "review", label: "Review & create", icon: "✦" },
  { id: "result", label: "Done", icon: "✓" },
];

const ORDER = STEPS.map((s) => s.id);

function stepIndex(stage) {
  if (stage === "uploading") return ORDER.indexOf("review");
  const idx = ORDER.indexOf(stage);
  return idx >= 0 ? idx : 0;
}

export default function BulkUploadStepBar({ stage }) {
  const current = stepIndex(stage);

  return (
    <div
      className="rounded-2xl border border-indigo-100 overflow-hidden"
      style={{ background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 60%, #e0e7ff 100%)" }}
    >
      <div className="px-4 pt-3 pb-1">
        <p className="text-[11px] font-bold uppercase tracking-widest text-indigo-400">
          Bulk import workflow
        </p>
      </div>
      <ol className="flex flex-wrap gap-1.5 p-3 md:flex-nowrap md:gap-0 md:items-center">
        {STEPS.map((step, i) => {
          const done = i < current || stage === "result";
          const active = i === current && stage !== "result";
          return (
            <li key={step.id} className="flex items-center min-w-0">
              <div
                className="flex items-center gap-2 px-3 py-1.5 rounded-xl text-xs font-semibold whitespace-nowrap transition-all duration-200"
                style={
                  active
                    ? { background: "linear-gradient(135deg, #4f46e5, #7c3aed)", color: "#fff", boxShadow: "0 4px 14px rgba(99,72,237,0.35)" }
                    : done
                    ? { background: "#d1fae5", color: "#065f46", border: "1px solid #a7f3d0" }
                    : { background: "rgba(255,255,255,0.5)", color: "#94a3b8", border: "1px solid #e2e8f0" }
                }
              >
                <span
                  className="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold shrink-0"
                  style={
                    active
                      ? { background: "rgba(255,255,255,0.25)", color: "#fff" }
                      : done
                      ? { background: "#6ee7b7", color: "#064e3b" }
                      : { background: "#e2e8f0", color: "#94a3b8" }
                  }
                >
                  {done ? <Check size={11} strokeWidth={3} /> : i + 1}
                </span>
                {step.label}
              </div>
              {i < STEPS.length - 1 ? (
                <span className="hidden md:inline mx-2 text-indigo-300 font-bold text-xs">›</span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
